import { useMemo } from 'react';
import { resolveForm } from './formConditions';

// What the answers so far make of a form: each calculation's result, and the
// questions and sections their conditions are hiding (`hiddenIds`). Worked out
// together because each depends on the other — a calculation leaves out the
// answer to a hidden question, and a condition can wait on a calculation. See
// resolveForm for the rules, and for `keepAnswered`, which reading a
// submission back uses so nothing recorded drops out of view.
export const useResolvedForm = (schema, formData, { keepAnswered = false } = {}) =>
  useMemo(
    () => resolveForm(schema, formData, { keepAnswered }),
    [schema, formData, keepAnswered],
  );

export default useResolvedForm;
